import { Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import SearchInput from "components/SearchInput";
import TableList from "components/TableList";

const headers = ["Reg", "Make"];

const items = [
  {
    id: 1,
    Account: "Bolton",
    Town: "Refund",
  },
  {
    id: 2,
    Account: 2,
    Town: "Bolton2",
  },
];

function Refund() {
  // const [isLoading, setIsLoading] = useState(false);
  // const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const onChangeSearchTxt = (v) => {
    // setSearchTxt(v);
    // getList({ searchTxt: v, dealerid: utils.getDealerid(dealers), page: 1 });
    // setSearchLoading(true);
  };

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Pricing And Refunds"} isLoading={false} />
      <Flex justifyContent="space-between" gap={"3"}>
        {/* <DropDown/> */}
        <SearchInput
          placeholder="Search"
          onChange={onChangeSearchTxt}
          // loading={searchLoading}
        />
        {/* <Button variant="outline" onClick={onNew}>New</Button> */}
      </Flex>
      <TableList headers={headers} items={items} />
    </Flex>
  );
}

export default Refund;
